// TODO: This can be moved to a shared file
import { usePage } from '@inertiajs/react';
import { PageProps } from '@inertiajs/core';
import { useEffect, useState } from 'react';
import { Alert, Box, Popper } from '@mui/material';

interface FlashProps extends PageProps {
  flash: {
    notice: string;
    alert: string;
  };
}

export function Notification() {
  const flash = usePage<FlashProps>().props.flash || {};
  const [showNotice, setShowNotice] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setShowNotice(!!flash.notice);
  }, [flash]);
  
  useEffect(() => {
    setShowError(!!flash.alert);
  }, [flash]);

  return (
    <>
      <Popper
        open={showNotice}
        anchorEl={document.querySelector('header')}
        placement="bottom"
        sx={{position: 'fixed', right: 24, zIndex: 2000}}
      >
        <Box>
          <Alert severity="success" sx={{ mb: 1, boxShadow: 3, minWidth: '300px' }} onClose={() => setShowNotice(false)}>
            {flash.notice}
          </Alert>
        </Box>
      </Popper>
      <Popper
        open={showError}
        anchorEl={document.querySelector('header')}
        placement="bottom"
        sx={{ position: 'fixed', right: 24, zIndex: 2000}}
      >
        <Box>
          <Alert severity="error" sx={{mb: 1, boxShadow: 3, minWidth: '300px'}} onClose={() => setShowError(false)}>
            {flash.alert}
          </Alert>
        </Box>
      </Popper>
    </>
  )
}